import * as React from 'react';
import styled from 'styled-components';
import { OnlineThemeType } from '../../themes/online';
import IAdditionStyle from '../../models/IAdditionStyle';

// ############################ Styles ###########################
// tslint:disable:variable-name

const getSize = (theme: OnlineThemeType, size: string) => {
  switch (size) {
    case 'small':
      return `
        font-size: ${theme.font.size.smallMedium};
        line-height: 2.85;
        `;
    case 'medium':
      return `
        font-size: ${theme.font.size.smallMedium3};
        line-height: 1.29;
      `;
    case 'large':
      return `
        font-size: ${theme.font.size.medium3};
        line-height: 1.21;
      `;
    case 'larger':
      return `
        font-size: ${theme.font.size.mediumLarge};
        line-height: 2.02;
      `;

    default:
      break;
  }
};

const SSubTitle = styled.h2<{ size: string }>(({ theme, size }) => {
  return `
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  font-size: ${theme.font.size.smallMedium2};
  font-weight: ${theme.font.weight.light};
  color: ${theme.colors.headlineGrey4};
  ${getSize(theme, size)}
  `;
});

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface ITitleProps {
  children: string;
  dataAt?: string;
  style?: IAdditionStyle;
  size?: string;
  className?: string;
}

export default ({ className, children, dataAt, style = {}, size = 'small' }: ITitleProps) => {
  return (
    <div data-at={dataAt}>
      <SSubTitle {...{ className, size, style }}>{children}</SSubTitle>
    </div>
  );
};
